import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { VARIANTS, SIZES, SQUARE_CHIP_COLORS } from './constant';
import styles from '@dtsl/css-chip/dist/index.module.css';
import ChevronDown from '@dtsl/icons/dist/icons/react/ChevronDown';
import ChevronUp from '@dtsl/icons/dist/icons/react/ChevronUp';
import ProgressiveIndicator from '@dtsl/icons/dist/icons/react/ProgressiveIndicator';

// eslint-disable-next-line react/display-name
const Chip = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    label = '',
    iconLeft = null,
    variant = VARIANTS.DEFAULT,
    onClick = () => {},
    disabled = false,
    className = '',
    iconRight = null,
    dropdownOpen = false,
    size = SIZES.MEDIUM,
    loading = false,
    isSelected = false,
    accessibleLabel = '',
    id = '',
    color = ''
  } = props;
  const chipClasses = classNames({
    [styles['sib-chip']]: true,
    [styles['sib-chip--selected']]: isSelected,
    [styles['sib-chip--loader']]: loading,
    [styles['sib-chip-icon']]: !!iconLeft,
    [styles['sib-chip-right-icon']]: !!iconRight,
    [styles['dropdown-open']]: dropdownOpen,
    [styles[`sib-chip--${variant}`]]: variant !== VARIANTS.DEFAULT,
    [styles[`sib-chip_size--${size}`]]: size !== SIZES.MEDIUM,
    [styles[color]]: !!color,
    [className]: !!className
  });
  const loadingClasses = classNames({
    [styles['sib-loader-icon']]: true,
    [styles['sib-chip-icon']]: true
  });
  const dropdownIcon = dropdownOpen ? /*#__PURE__*/React.createElement(ChevronUp, null) : /*#__PURE__*/React.createElement(ChevronDown, null);
  const iconLeftInChip = loading ? /*#__PURE__*/React.createElement(ProgressiveIndicator, {
    className: loadingClasses
  }) : iconLeft ? iconLeft : null;
  const iconRightInChip = variant === 'selectableWithPanel' ? dropdownIcon : iconRight;
  return /*#__PURE__*/React.createElement("span", {
    role: "presentation",
    ref: ref,
    disabled: disabled,
    tabIndex: disabled ? '-1' : '0',
    className: chipClasses,
    onClick: onClick,
    onKeyDown: event => {
      if (event.key === 'Enter') {
        onClick(event);
      }
    },
    id: id
  }, iconLeftInChip ? iconLeftInChip : null, accessibleLabel && /*#__PURE__*/React.createElement("span", {
    className: styles['sib-sr-only']
  }, accessibleLabel), /*#__PURE__*/React.createElement("span", {
    className: styles['sib-chip-label']
  }, label), iconRightInChip ? iconRightInChip : null);
});
Chip.propTypes = {
  variant: PropTypes.oneOf(Object.values(VARIANTS)),
  label: PropTypes.string,
  accessibleLabel: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
  iconLeft: PropTypes.node,
  iconRight: PropTypes.node,
  dropdownOpen: PropTypes.bool,
  size: PropTypes.oneOf(Object.values(SIZES)),
  loading: PropTypes.bool,
  isSelected: PropTypes.bool,
  id: PropTypes.string,
  color: PropTypes.oneOf(Object.values(SQUARE_CHIP_COLORS))
};
export default Chip;